export enum FaceValidationStatus {
  PASS = 'PASS',
  FAIL = 'FAIL',
  PENDING = 'PENDING',
}

export type FaceValidationKey =
  | 'faceCentered'
  | 'headStraight'
  | 'goodLighting'
  | 'clearNoBlur'
  | 'eyesVisible'
  | 'faceClearlyVisible'
  | 'singleFaceDetected'
  | 'correctDistance';

export type FaceValidationResult = Record<FaceValidationKey, FaceValidationStatus>;

export const FACE_VALIDATION_KEYS: FaceValidationKey[] = [
  'faceCentered',
  'headStraight',
  'goodLighting',
  'clearNoBlur',
  'eyesVisible',
  'faceClearlyVisible',
  'singleFaceDetected',
  'correctDistance',
];
